import { find } from 'lodash';
import {
  RENTAL_CREATED,
  RENTAL_UPDATED,
  RENTALS_FETCHED,
  UPCOMING_RENTALS_FETCHED,
  INPROGRESS_RENTALS_FETCHED,
  CLOSED_RENTALS_FETCHED,
  INPROGRESS_CARPOOLINGS_FETCHED,
  UPCOMING_CARPOOLINGS_FETCHED,
  PASSENGER_CREATED,
  PASSENGER_DELETED
} from '../actions/rentals';

const initialState = {
  closedStatuses: [],
  closedMeta: [],
  inProgressStatuses: [],
  upcomingStatuses: [],
  upcomingMeta: {},
  inProgressCarpoolings: [],
  upcomingCarpoolings: [],
  upcomingCarpoolingsMeta: {}
};

export default function rentalsReducer(state = initialState, action) {
  switch (action.type) {
    case 'UPCOMING_RENTALS_FETCHED':
      return {
        ...state,
        upcomingStatuses: action.rentals,
        upcomingMeta: action.meta
      };

    case 'INPROGRESS_RENTALS_FETCHED':
      return { ...state, inProgressStatuses: action.rentals };

    case 'CLOSED_RENTALS_FETCHED':
      return {
        ...state,
        closedStatuses: action.rentals,
        closedMeta: action.meta
      };

    case 'UPCOMING_CARPOOLINGS_FETCHED':
      return {
        ...state,
        upcomingCarpoolings: action.rentals,
        upcomingCarpoolingsMeta: action.meta
      };

    case 'INPROGRESS_CARPOOLINGS_FETCHED':
      return { ...state, inProgressCarpoolings: action.rentals };

    case 'RENTAL_CREATED': {
      const slice = getSliceName(action.rental.status);
      return { ...state, [slice]: [...state[slice], action.rental] };
    }

    case 'PASSENGER_DELETED': {
      return { ...state };
    }

    case 'RENTAL_UPDATED': {
      const slice = getSliceName(action.rental.status);

      const cleaned = Object.fromEntries(
        Object.entries(state).map(([key, arr]) => [
          key,
          Array.isArray(arr) ? arr.filter(r => r.id !== action.rental.id) : arr
        ])
      );

      return {
        ...cleaned,
        [slice]: [...cleaned[slice], action.rental]
      };
    }

    default:
      return state;
  }
}

function getSliceName(status) {
  if (status === 'in_progress') return 'inProgressStatuses';
  if (status === 'closed') return 'closedStatuses';
  return 'upcomingStatuses';
}
